import seinLogo from '@/images/icons/SEIN-Terminal-Logo.jpg';

function Footer() {
  return (
    <footer className='flex gap-2 bg-white py-2 px-5 text-sm w-full flex-col md:flex-row items-center'>
      <div className='container md:mx-auto flex flex-col md:flex-row items-center justify-around gap-4 md:px-8'>
        <div className='grow'>
          <p className=' text-neutralColor-normal flex gap-4  text-xs md:text-sm'>
            <a href='https://sein.tech/about' target='_blank' rel='noreferrer' className='hover:text-secondaryColor-normal cursor-pointer'>
              About
            </a>
            <a
              href='https://sein.tech/terms-of-use'
              target='_blank'
              rel='noreferrer'
              className='hover:text-secondaryColor-normal cursor-pointer'
            >
              Terms of use
            </a>
            <a
              href='https://sein.tech/privacy-policy'
              target='_blank'
              rel='noreferrer'
              className='hover:text-secondaryColor-normal cursor-pointer'
            >
              Privacy
            </a>
          </p>
        </div>

        <div className='grow space-y-3 md:space-y-1'>
          <div className='flex items-center gap-2'>
            <span className='text-neutralColor-normal text-xs'>Powered By:</span>
            <img src={seinLogo} alt='sein logo' className='w-auto h-10' />
          </div>
          <p className='lg:mx-auto text-neutralColor-normal text-xs'>
            &#169; <span>{new Date().getFullYear()}</span> SEIN Technology Partners.
          </p>
        </div>
        <div className='grow' />
      </div>
    </footer>
  );
}

export default Footer;
